import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  tabs: {
    padding: theme.spacing(0, 4),
    minHeight: "auto",
    "& .MuiTabs-indicator": {
      height: 3,
      backgroundColor: theme.palette.primary.main,
    },
    "& .MuiButtonBase-root": {
      minWidth: 'auto',
    },
  },
  tab: {
    minWidth: "auto",
    fontSize: 14,
    fontWeight: 500,
    textTransform: "none",
    minHeight: "auto",
    marginRight: theme.spacing(15),
  },
  tabPanel: {
    maxHeight: 480,
    overflow: "auto",
    padding: 0,
    "& .MuiBox-root": {
      padding: 0,
    },
  },
  list: {
    padding: 0,
    margin: 0,
    listStyle: "none",
    marginBottom: 1,
  },
  listItem: {
    display: "flex",
    alignItems: "center",
    borderBottom: "1px solid #F1F2F6",
  },
  listItemWithinDateRange: {
    background: 'rgba(255, 250, 229, 1)',
    borderLeft: '1px solid rgba(249, 208, 55, 1)',
    borderRight: '1px solid rgba(249, 208, 55, 1)',
    borderTop: 0,
    borderBottom: 0,
    '&:first-of-type': {
      borderTop: '1px solid rgba(249, 208, 55, 1)',
    },
    '&:last-of-type': {
      borderBottom: '1px solid rgba(249, 208, 55, 1)',
    }
  },
  icon: {
    width: "120px",
    maxWidth: "120px",
    flex: "0 0 120px",
    padding: theme.spacing(2.5, 5),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "rgb(182, 186, 193)",
    "& .MuiSvgIcon-root": {
      fontSize: "2rem",
    },
  },
  content: {
    padding: theme.spacing(2.5, 0),
    width: "calc(70% - 120px)",
    maxWidth: "calc(70% - 120px)",
    flex: "0 0 calc(70% - 120px)",
    display: "flex",
    alignItems: "start",
    flexDirection: "column",
  },
  contentText: {
    fontSize: 14,
    fontWeight: 500,
    color: "rgba(36, 42, 56, 1)",
  },
  contentTextLink: {
    color: "rgba(36, 42, 56, 1)",
    '&:hover, &:active': {
      color: "rgba(36, 42, 56, .7)",
    }
  },
  contentSubText: {
    fontSize: 12,
    fontWeight: 500,
    color: "rgba(163, 171, 182, 1)",
    marginTop: theme.spacing(1),
  },
  progress: {
    padding: theme.spacing(2.5, 5),
    width: "30%",
    maxWidth: "30%",
    flex: "0 0 30%",
    display: "flex",
    alignItems: "start",
    flexDirection: "column",
    "& .MuiLinearProgress-root": {
      height: "5px",
    },
    "& .MuiLinearProgress-colorPrimary": {
      backgroundColor: "rgb(198, 200, 202)",
      borderRadius: "10px",
    },
  },
  progressLabel: {
    fontSize: 12,
    fontWeight: 500,
    color: "rgba(209, 212, 213, 1)",
  },
  progressBar: {
    width: "100%",
    marginTop: theme.spacing(1),
  },
  activeLabel: {
    color: "rgb(65,175,54)",
  },
  loadMore: {
    cursor: "pointer",
    padding: "10px",
    textAlign: "center",
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    "& .MuiCircularProgress-root": {
      width: "18px!important",
      height: "18px!important",
      marginRight: "20px",
    },
  },
  rotateLeftIcon: {
    marginRight: "8px",
  },
}));
